import React, { Component } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import styled from 'styled-components';
import axios from 'axios';

import StartButton from '../../../components/StartButton';

export default class Overview extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      drawing: false,
    };
  }

  onSubmit() {
    const dataUrl = this.ref.toDataURL();

    const { completeContractToken, allData } = this.props;

    const {
      contact,
      address,
      account,
      contract,
    } = allData;

		axios.post('/api/account/complete-contract-data', {
      completeContractToken,
      contact,
      address,
      account,
      contract,
      signature: {
        dataUrl,
      },
		}).then(({ data }) => {
      console.log('done', data);
      this.props.onSubmit();
    }).catch((err) => {
      console.log('error', err);
    });
  }

  render() {
    return (
      <div style={{ marginTop: 50 }}>
        <div style={{
          borderRadius: 5,
          border: '1px solid #cecece',
          width: 945,
          margin: 'auto',
          height: 500
        }} onMouseDown={() => this.setState({ drawing: true })}>
          <SignatureCanvas
            ref={(ref) => { this.ref = ref; }}
            canvasProps={{ width: 945, height: 500 }}
          />
          { !this.state.drawing ? (
            <div style={{
              textAlign: 'center',
              fontSize: 50,
              color: '#e5e5e5',
              marginTop: -300,
              width: 500,
              marginLeft: 'auto',
              marginRight: "auto"
            }}>
              SIGN HERE WITH YOUR FINGER...
            </div>
          ) : null }
        </div>
        <CenteredSection>
          <div style={{}}>
            <StartButton text="SUBMIT" onSubmit={this.onSubmit} />
          </div>
        </CenteredSection>
      </div>
    )
  }
}

const CenteredSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  alignItems: center;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/pages/Signature/index.js